import type { Platform } from '~/types/graphql';

export const STORE_PLATFORM: Record<Platform, Platform> = {
  BIG: 'BIG',
  SHOPIFY: 'SHOPIFY',
  WOO: 'WOO',
};
